/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Wizard_Step3_Embed_On_Sync_DescriptionInputs */



/**
* | output |
* | --- |
* | "When this space is synced, newly discovered files will be automatically embedded so they are ready to use in AI chats without any extra steps." |
*
* @param {Spaces_Wizard_Step3_Embed_On_Sync_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_wizard_step3_embed_on_sync_description = /** @type {((inputs?: Spaces_Wizard_Step3_Embed_On_Sync_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Wizard_Step3_Embed_On_Sync_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Wenn dieser Space synchronisiert wird, werden neu entdeckte Dateien automatisch embedden, sodass sie ohne zusätzliche Schritte in AI-Chats verwendet werden können.")
	return /** @type {LocalizedString} */ ("When this space is synced, newly discovered files will be automatically embedded so they are ready to use in AI chats without any extra steps.")
});